import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { PessoaService } from 'src/app/services/pessoa.service';

@Component({
    selector: 'pessoa-dropdown',
    templateUrl: './pessoa-dropdown.component.html',
    styleUrls: ['./pessoa-dropdown.component.css']
})
export class PessoaDropdownComponent implements OnInit {

    @Input() pessoaId!: any | any;
    @Input() selecionaMultiplos!: Boolean | false;
    @Output() pessoaIdChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() change: EventEmitter<any> = new EventEmitter<any>();
    private searchText$ = new Subject<string>();
    subscription: Subscription;

    public pessoas: any = [];
    public loadPessoas: boolean = false;
    public pessoa: any;
    public pessoasSelecionadas: any[] = [];
    public selecionarTodosMarcado: boolean = false;

    constructor(
        private pessoaService: PessoaService
    ) { }

    ngOnInit(): void {
        this.subscription = this.searchText$
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((value: string) => {   
                this.buscarPessoa(value);                    
            }
        );

        if (this.pessoaId != undefined && this.pessoaId != null && this.pessoaId != '') {
            this.buscarPorId();
        } else {
            this.buscarPessoa('a');
        }        
    }

    selecionarPessoa(pessoaId: any): void {

        this.pessoaId = pessoaId;

        if(this.pessoaId)
            this.buscarPorId();

        this.pessoaIdChange.emit(this.pessoaId);
    }

    changePessoa($event) {

        this.pessoaIdChange.emit(this.pessoaId);
        this.change.emit(this.pessoas.filter(x => x.id == this.pessoaId)[0]);
    }

    adicionarPessoaSelecionada(pessoa: any): void {
        if (this.selecionaMultiplos && pessoa && !this.pessoasSelecionadas.some(selecionada => selecionada.id === pessoa.id)) {
            this.pessoasSelecionadas.push(pessoa);
        }
    }

    removerPessoaSelecionada(pessoa: any): void {
        if (this.selecionaMultiplos && pessoa) {
            this.pessoasSelecionadas = this.pessoasSelecionadas.filter(selecionada => selecionada.id !== pessoa.id);
        }

        this.selecionarTodosMarcado = false;
    }

    get todasPessoasSelecionadas(): boolean {
        if (!this.selecionaMultiplos || !this.pessoas || this.pessoas.length === 0) {
            return false;
        }

        const pessoasSelecionadas = Array.isArray(this.pessoaId) ? this.pessoaId : [];
        return this.pessoas.every(pessoa => pessoasSelecionadas.includes(pessoa.id));
    }

    alternarSelecaoTodas(event: Event): void {
        event.stopPropagation();

        const marcado = (event.target as HTMLInputElement).checked;
        this.selecionarTodosMarcado = marcado;
        this.pessoaId = marcado
            ? Array.from(new Set([...(Array.isArray(this.pessoaId) ? this.pessoaId : []), ...this.pessoas.map(pessoa => pessoa.id)]))
            : [];
        this.pessoasSelecionadas = marcado ? [...this.pessoasSelecionadas, ...this.pessoas.filter(pessoa => !this.pessoasSelecionadas.some(selecionada => selecionada.id === pessoa.id))] : [];

        this.pessoaIdChange.emit(this.pessoaId);
        this.change.emit(marcado ? this.pessoas : []);
    }

    limparPessoa() {

        this.pessoaIdChange.emit(null);
        this.pessoasSelecionadas = [];
        this.selecionarTodosMarcado = false;
    }

    filtrar(term: any) {

        if (term.keyCode == 38 || term.keyCode == 40) return;

        if (term.keyCode == 13) {
            this.changePessoa(null);
        }

        if (term.target.value != '') {            
            this.searchText$.next(term.target.value);            
            //this.buscarPessoa(term.target.value);
        }        
    }

    buscarPessoa(buscar) {
        
        this.loadPessoas = true;

        this.pessoaService.obterPessoaFiltroNomeAsync(buscar).then(x => {

            this.loadPessoas = false;
            const pessoasEncontradas = x.data || [];
            this.pessoas = [...this.pessoasSelecionadas, ...pessoasEncontradas.filter(pessoa => !this.pessoasSelecionadas.some(selecionada => selecionada.id === pessoa.id))];

            this.selecionarTodosMarcado = false;
            if (!this.selecionaMultiplos && this.pessoa != undefined && !this.pessoas.some(pessoa => pessoa.id === this.pessoa.id))
                this.pessoas.push(this.pessoa);

        });
    }

    buscarPorId() {

        this.loadPessoas = true;

        if (Array.isArray(this.pessoaId)) {
            Promise.all(this.pessoaId.map(id => this.pessoaService.getByIdAsync(id)))
                .then(respostas => {
                    this.loadPessoas = false;
                    this.pessoasSelecionadas = respostas.map(resposta => resposta.data);
                    this.pessoas = this.pessoasSelecionadas;
                })
                .catch(() => {
                    this.loadPessoas = false;
                });

            return;
        }

        this.pessoaService.getByIdAsync(this.pessoaId)
            .then(res => {
                this.loadPessoas = false;
                let pessoas = [];
                pessoas.push(res.data);
                this.pessoa = res.data;
                this.pessoasSelecionadas = pessoas;
                this.pessoas = pessoas;
            })
    }
}
